<template>
  <Div class="course">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          v-if="popup=='check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess v-if="popup=='success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup=='error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="addCourse">
      <button class="btn_primary" @click="goAdd">新增教材與試題</button>
    </div>
    <div class="list contain_white">
      <div class="course_item flex" v-for="(course,index) in data" :key="index">
        <div class="action flex">
          <Div @click="edit(course,index)">
            <i class="el-icon-edit-outline"></i>
          </Div>
          <div @click="del(course,index)">
            <i class="el-icon-delete"></i>
          </div>
        </div>
        <div class="couser_name">{{course.course_name}}</div>
      </div>
    </div>
  </Div>
</template>
<style lang="scss">
.course {
  .list {
    margin: 20px 0;
    .course_item {
      margin: 15px 0;
      padding: 15px 0;
      border-bottom: 1px solid #e1e3ee;
      align-items: center;
      &:last-child {
        border-bottom: none;
      }
      .action {
        flex: 1.5;
        > div {
          cursor: pointer;
          background: #efefef;
          padding: 4px;
          border-radius: 3px;
          margin: 0 10px 0 0;
          i {
            color: #777;
          }
          &:hover {
            transform: scale(1.1);
            color: #fff;
            background: var(--mainColor);
            i {
              color: #fff;
            }
          }
        }
      }
      .couser_name {
        flex: 8.5;
      }
    }
  }
}
</style>
<script>
import AddCourse from "@/components/admin/AddCourse.vue";
export default {
  name: "courseList",
  data() {
    return {
      data: [],
      popupStatus: false,
      successText: null,
      popup: null,
      actionIndex: null,
      actionId: null
    };
  },
  components: {
    AddCourse
  },
  created() {
    this.getData();
  },
  methods: {
    goAdd() {
      this.$router.push({
        name: "course_detailed"
      });
    },
    getData() {
      this.$http.api.admin.course().then(res => {
        this.data = res.data;
      });
    },
    del(item, index) {
      this.actionIndex = index;
      this.actionId = item.course_id;
      this.popupStatus = true;
      this.successText = "確定刪除嗎";
      this.popup = "check";
    },
    edit(item, index) {
      this.$router.push({
        name: "course_detailed",
        query: {
          course_id: item.course_id
        }
      });
    },
    popupAction() {
      console.log("執行刪除");
      this.$http.api.admin
        .courseDel(this.actionId)
        .then(res => {
          this.popupStatus = true;
          this.successText = "刪除成功";
          this.popup = "success";
        })
        .catch(error => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "刪除失敗";
        });
    },
    poupupEnter() {
      this.popupStatus = false;
      this.getData();
    }
  }
};
</script>